<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import { ADMIN_MICOAPP_API } from "@/config/social-api";
import {
  summarizeMicoappLogData,
  parseMicoappLogTimeMs,
} from "@/utils/micoapp-logs";

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      title: "消息通知",
      items: [],
      userinfo: {},
      list: [],
      loading: false,
      total: 0,
      page: 1,
      pageSize: 20,
    };
  },
  mounted() {
    try {
      this.userinfo = JSON.parse(localStorage.getItem("user") || "{}");
    } catch (e) {
      this.userinfo = {};
    }
    this.items = [
      { text: this.$t("dashboard.text"), href: "/" },
      { text: "消息通知", active: true },
    ];
    this.fetchLogs();
  },
  methods: {
    logSummary(row) {
      return summarizeMicoappLogData(row && row.data);
    },
    logTimeMs(row) {
      return parseMicoappLogTimeMs(row && row.time);
    },
    formatTime(row) {
      const ms = this.logTimeMs(row);
      if (ms) {
        const d = new Date(ms);
        if (!Number.isNaN(d.getTime())) {
          const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
          return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
            d.getDate()
          )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(
            d.getSeconds()
          )}`;
        }
      }
      return (row && row.time) || "—";
    },
    goApp(appid) {
      if (!appid || !this.$router) return;
      const path = `/micoapp/${encodeURIComponent(appid)}`;
      if (this.$route.path === path) return;
      this.$router.push({ path }).catch((err) => {
        if (err && err.name !== "NavigationDuplicated") {
          console.error(err);
        }
      });
    },
    fetchLogs() {
      const openid = this.userinfo && this.userinfo.openid;
      if (!openid) {
        this.$message.warning("请先登录");
        return;
      }
      this.loading = true;
      this.$axios
        .post(
          ADMIN_MICOAPP_API,
          {
            action: "get_micoapp_logs",
            page: this.page,
            page_size: this.pageSize,
          },
          { headers: { Openid: openid } }
        )
        .then((res) => {
          const body = res && res.data ? res.data : {};
          if (Number(body.status) === 403) {
            this.$message.error("无权限");
            this.list = [];
            this.total = 0;
            return;
          }
          this.list = Array.isArray(body.data) ? body.data : [];
          this.total =
            typeof body.total === "number"
              ? body.total
              : parseInt(body.total, 10) || 0;
        })
        .catch((e) => {
          console.error(e);
          this.$message.error("加载失败");
          this.list = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onPageChange(p) {
      this.page = p;
      this.fetchLogs();
    },
    onSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.fetchLogs();
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card micoapp-notifications-page">
      <div class="card-body">
        <div
          class="d-flex flex-wrap justify-content-between align-items-center mb-3"
        >
          <p class="text-muted small mb-0">
            展示当前账号下小程序相关的全部接口与回调日志（分页）。
          </p>
          <el-button
            type="primary"
            plain
            size="small"
            :loading="loading"
            @click="fetchLogs"
          >
            刷新
          </el-button>
        </div>
        <el-table
          v-loading="loading"
          :data="list"
          stripe
          style="width: 100%"
          class="micoapp-notifications-table"
        >
          <el-table-column prop="id" label="ID" width="88" />
          <el-table-column
            prop="appid"
            label="AppID"
            width="148"
            show-overflow-tooltip
          />
          <el-table-column label="摘要" min-width="320" class-name="micoapp-log-summary-col">
            <template slot-scope="scope">
              <div class="micoapp-log-summary-text">
                {{ logSummary(scope.row) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="时间" width="176">
            <template slot-scope="scope">
              {{ formatTime(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="112" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                :disabled="!scope.row.appid"
                @click="goApp(scope.row.appid)"
              >
                进入小程序
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-3 d-flex justify-content-end flex-wrap">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :current-page="page"
            @current-change="onPageChange"
            @size-change="onSizeChange"
          />
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.micoapp-notifications-page .micoapp-notifications-table {
  font-size: 13px;
}

.micoapp-log-summary-text {
  white-space: pre-line;
  line-height: 1.6;
  font-size: 13px;
  color: #343a40;
  word-break: break-word;
}
</style>

<style>
/* 摘要列多行展示（Element 表格单元格） */
.micoapp-notifications-table .micoapp-log-summary-col .cell {
  line-height: 1.6;
}
</style>
